"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _Pill = _interopRequireDefault(require("@mulesoft/anypoint-components/raw/components/Pill"));
var _Icon = _interopRequireDefault(require("@mulesoft/anypoint-icons/lib/Icon"));
var _exchangeUiComponents = require("@mulesoft/exchange-ui-components");
var _exchangeReactHooks = require("@mulesoft/exchange-react-hooks");
var _classnames = _interopRequireDefault(require("classnames"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _reactRouterDom = require("react-router-dom");
var dateUtils = _interopRequireWildcard(require("../../utils/date"));
var eventsUtils = _interopRequireWildcard(require("../../utils/events"));
var _Matches = _interopRequireDefault(require("./Matches"));
var _Pages = _interopRequireDefault(require("./Pages"));
var _Statuses = _interopRequireDefault(require("./Statuses"));
var _Versions = _interopRequireDefault(require("./Versions"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2.default)(o), (0, _possibleConstructorReturn2.default)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2.default)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); } /* eslint-disable react/state-in-constructor */
var OrganizationIcon = function OrganizationIcon(props) {
  return /*#__PURE__*/_react.default.createElement("svg", props, /*#__PURE__*/_react.default.createElement("path", {
    d: "M5 4.99a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v14h1a1 1 0 1 1 0 2H4a1 1 0 1 1 0-2h1v-14zm12 14v-14H7v14h2v-2c0-1.102.898-2 2-2h2c1.102 0 2 .898 2 2v2h2zm-4 0v-2h-2v2h2zm-4-11a1 1 0 0 1 1-1h4a1 1 0 1 1 0 2h-4a1 1 0 0 1-1-1zm0 4a1 1 0 0 1 1-1h4a1 1 0 1 1 0 2h-4a1 1 0 0 1-1-1z"
  }));
};
OrganizationIcon.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
var MinorVersionModifiedAtIcon = function MinorVersionModifiedAtIcon(props) {
  return /*#__PURE__*/_react.default.createElement("svg", props, /*#__PURE__*/_react.default.createElement("path", {
    d: "M8 2a1 1 0 0 1 1 1v1h6V3a1 1 0 1 1 2 0v1h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2V3a1 1 0 0 1 1-1zM7 6H5v3.99h14V6h-2v1a1 1 0 1 1-2 0V6H9v1a1 1 0 0 1-2 0V6zm12 5.99H5V20h14v-8.01z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M10 14H8a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1z"
  }));
};
MinorVersionModifiedAtIcon.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
var UserIcon = function UserIcon(props) {
  return /*#__PURE__*/_react.default.createElement("svg", props, /*#__PURE__*/_react.default.createElement("path", {
    d: "M12 5a3 3 0 1 0 0 6 3 3 0 0 0 0-6zM7 8a5 5 0 1 1 10 0A5 5 0 0 1 7 8zm2.321 6.533A7.001 7.001 0 0 1 19 21a1 1 0 1 1-2 0 5 5 0 1 0-10 0 1 1 0 1 1-2 0 7 7 0 0 1 4.321-6.467z"
  }));
};
UserIcon.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
var styles = {
  "container": "AssetCard__container__1teJw",
  "asset-title": "AssetCard__asset-title__3WiAo",
  "assetTitle": "AssetCard__asset-title__3WiAo",
  "asset-card": "AssetCard__asset-card__2iQEf",
  "assetCard": "AssetCard__asset-card__2iQEf",
  "override": "AssetCard__override__33nJK",
  "description": "AssetCard__description__3MpvF",
  "version": "AssetCard__version__1Abn0",
  "detail": "AssetCard__detail__29UNK",
  "rating": "AssetCard__rating__2yb0N",
  "name": "AssetCard__name__1vrTi",
  "icon": "AssetCard__icon__AoJmh",
  "tags-container": "AssetCard__tags-container__2t7B7",
  "tagsContainer": "AssetCard__tags-container__2t7B7",
  "matches-tags": "AssetCard__matches-tags__1ABXA",
  "matchesTags": "AssetCard__matches-tags__1ABXA",
  "matches-categories": "AssetCard__matches-categories__1PQSu",
  "matchesCategories": "AssetCard__matches-categories__1PQSu",
  "matches-table": "AssetCard__matches-table__3KrTq",
  "matchesTable": "AssetCard__matches-table__3KrTq",
  "row-title": "AssetCard__row-title__1EWa5",
  "rowTitle": "AssetCard__row-title__1EWa5",
  "row-content": "AssetCard__row-content__18NmT",
  "rowContent": "AssetCard__row-content__18NmT",
  "metadata": "AssetCard__metadata__1HjVL",
  "number-of-rates": "AssetCard__number-of-rates__2AViT",
  "numberOfRates": "AssetCard__number-of-rates__2AViT",
  "metadata-item": "AssetCard__metadata-item__2ztCa",
  "metadataItem": "AssetCard__metadata-item__2ztCa",
  "metadata-item-wrapper": "AssetCard__metadata-item-wrapper__DMBFE",
  "metadataItemWrapper": "AssetCard__metadata-item-wrapper__DMBFE"
}; 
require('./AssetCard.css');
var AssetCard = /*#__PURE__*/function (_React$Component) {
  function AssetCard(props) {
    var _this;
    (0, _classCallCheck2.default)(this, AssetCard);
    _this = _callSuper(this, AssetCard, [props]);
    (0, _defineProperty2.default)(_this, "loadCardState", function () {
      var startExpanded = _this.props.startExpanded;
      return {
        isExpanded: startExpanded
      };
    });
    (0, _defineProperty2.default)(_this, "onFetchPagesStart", function () {
      return _this.setState({
        hasFetchedPages: true
      });
    });
    (0, _defineProperty2.default)(_this, "onFetchPagesEnd", function (pages) {
      return _this.setState({
        pages: pages
      });
    });
    (0, _defineProperty2.default)(_this, "onFetchVersionsStart", function (fetchVersionsPromise, titleWidths) {
      return _this.setState({
        hasFetchedVersions: true,
        fetchVersionsPromise: fetchVersionsPromise,
        titleWidths: titleWidths
      }, _this.saveCardState);
    });
    (0, _defineProperty2.default)(_this, "onFetchVersionsEnd", function (versions) {
      var newState = {
        versions: versions,
        fetchVersionsPromise: null,
        titleWidths: null
      };
      _this.setState(newState);
    });
    (0, _defineProperty2.default)(_this, "handleMatchesToggle", function (_ref) {
      var isCollapsed = _ref.isCollapsed,
        matchId = _ref.matchId;
      var isExpanded = !isCollapsed;
      var isPagesExpanded = isExpanded && matchId === 'pages';
      var isVersionsExpanded = isExpanded && matchId === 'versions';
      _this.setState({
        isPagesExpanded: isPagesExpanded,
        isVersionsExpanded: isVersionsExpanded,
        isExpanded: isExpanded
      });
    });
    (0, _defineProperty2.default)(_this, "onImageError", function () {
      return _this.setState({
        hasIconError: true
      }, _this.saveCardState);
    });
    _this.state = _this.loadCardState();
    return _this;
  }
  (0, _inherits2.default)(AssetCard, _React$Component);
  return (0, _createClass2.default)(AssetCard, [{
    key: "getType",
    value: function getType() {
      var type = this.props.type;
      var assetTypesConfiguration = this.context;
      if (assetTypesConfiguration[type]) {
        return "".concat(assetTypesConfiguration[type].name, ". ");
      }
      return '';
    }
  }, {
    key: "buildAssetPath",
    value: function buildAssetPath(getPath) {
      var _this$props = this.props,
        groupId = _this$props.groupId,
        assetId = _this$props.assetId,
        minorVersion = _this$props.minorVersion,
        highlightedStatus = _this$props.highlightedStatus;
      var path = getPath('minor', {
        groupId: groupId,
        assetId: assetId,
        minorVersion: minorVersion
      });
      if (highlightedStatus) {
        return "".concat(path, "?status=").concat(highlightedStatus);
      }
      return path;
    }
  }, {
    key: "buildCardLabel",
    value: function buildCardLabel() {
      var _this$props2 = this.props,
        createdBy = _this$props2.createdBy,
        name = _this$props2.name,
        rating = _this$props2.rating;
      var label = "".concat(name, ". ").concat(this.getType());
      if (rating === 0) {
        label += 'No rating. ';
      } else {
        label += "".concat(rating, " stars. ");
      }
      if (createdBy) {
        label += "Created by ".concat(createdBy, ".");
      }
      return label;
    }
  }, {
    key: "renderRating",
    value: function renderRating() {
      var _this$props3 = this.props,
        numberOfRates = _this$props3.numberOfRates,
        rating = _this$props3.rating;
      return /*#__PURE__*/_react.default.createElement("span", {
        className: styles.rating,
        "data-test-id": "asset-card-rating"
      }, /*#__PURE__*/_react.default.createElement(_exchangeUiComponents.Rating, {
        rating: rating
      }), /*#__PURE__*/_react.default.createElement("span", {
        className: styles.numberOfRates
      }, "(", numberOfRates, ")"));
    }
  }, {
    key: "renderType",
    value: function renderType() {
      var type = this.props.type;
      return /*#__PURE__*/_react.default.createElement(_exchangeUiComponents.AssetType, {
        type: type
      });
    }
  }, {
    key: "renderOrganization",
    value: function renderOrganization() {
      var _this$props4 = this.props,
        highlight = _this$props4.highlight,
        organization = _this$props4.organization;
      return /*#__PURE__*/_react.default.createElement("div", {
        className: styles.metadataItemWrapper,
        title: "Organization"
      }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
        className: styles.icon,
        "aria-hidden": true
      }, /*#__PURE__*/_react.default.createElement(OrganizationIcon, null)), /*#__PURE__*/_react.default.createElement("span", {
        "data-test-id": "asset-card-organization",
        className: styles.metadataItem
      }, highlight !== null && highlight !== void 0 && highlight.organization ? /*#__PURE__*/_react.default.createElement(_exchangeUiComponents.Highlight, null, highlight.organization) : organization));
    }
  }, {
    key: "renderUser",
    value: function renderUser() {
      var _this$props5 = this.props,
        createdBy = _this$props5.createdBy,
        highlight = _this$props5.highlight;
      return /*#__PURE__*/_react.default.createElement("div", {
        className: styles.metadataItemWrapper,
        title: "Created by"
      }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
        className: styles.icon,
        "aria-hidden": true
      }, /*#__PURE__*/_react.default.createElement(UserIcon, null)), /*#__PURE__*/_react.default.createElement("span", {
        "data-test-id": "asset-card-user",
        className: styles.metadataItem
      }, highlight && highlight.createdBy ? /*#__PURE__*/_react.default.createElement(_exchangeUiComponents.Highlight, null, highlight.createdBy) : createdBy));
    }
  }, {
    key: "renderModifiedAt",
    value: function renderModifiedAt() {
      var minorVersionModifiedAt = this.props.minorVersionModifiedAt;
      return /*#__PURE__*/_react.default.createElement("div", {
        className: styles.metadataItemWrapper,
        title: "Last modified date"
      }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
        className: styles.icon,
        "aria-hidden": true
      }, /*#__PURE__*/_react.default.createElement(MinorVersionModifiedAtIcon, null)), /*#__PURE__*/_react.default.createElement("span", {
        "data-test-id": "asset-card-modified-at",
        className: styles.metadataItem
      }, dateUtils.formatDate(minorVersionModifiedAt)));
    }
  }, {
    key: "renderStatuses",
    value: function renderStatuses() {
      var highlight = this.props.highlight;
      return /*#__PURE__*/_react.default.createElement(_Statuses.default, {
        statuses: highlight === null || highlight === void 0 ? void 0 : highlight.statuses
      });
    }
  }, {
    key: "getMetadata",
    value: function getMetadata() {
      return [this.renderRating(), this.renderType(), this.renderOrganization(), this.renderUser(), this.renderModifiedAt(), this.renderStatuses()];
    }
  }, {
    key: "renderMetadata",
    value: function renderMetadata() {
      return /*#__PURE__*/_react.default.createElement("ul", {
        className: styles.metadata,
        "data-test-id": "asset-card-metadata"
      }, this.getMetadata().map(function (element, index) {
        return /*#__PURE__*/_react.default.createElement("li", {
          key: "metadata-".concat(index)
        }, element);
      }));
    }
  }, {
    key: "renderDescription",
    value: function renderDescription() {
      var _this$props6 = this.props,
        highlight = _this$props6.highlight,
        description = _this$props6.description;
      return highlight !== null && highlight !== void 0 && highlight.description || description ? /*#__PURE__*/_react.default.createElement("p", {
        "data-test-id": "asset-card-description",
        className: styles.description
      }, highlight !== null && highlight !== void 0 && highlight.description ? /*#__PURE__*/_react.default.createElement(_exchangeUiComponents.Highlight, null, highlight.description) : description) : null;
    }
  }, {
    key: "renderPages",
    value: function renderPages() {
      var _this$props7 = this.props,
        highlight = _this$props7.highlight,
        groupId = _this$props7.groupId,
        assetId = _this$props7.assetId,
        minorVersion = _this$props7.minorVersion,
        searchTerm = _this$props7.searchTerm;
      var _this$state = this.state,
        hasFetchedPages = _this$state.hasFetchedPages,
        isPagesExpanded = _this$state.isPagesExpanded,
        pages = _this$state.pages;
      if (!highlight || !highlight.pages || !highlight.pages.length) {
        return null;
      }
      return /*#__PURE__*/_react.default.createElement(_Pages.default, {
        pages: pages || highlight.pages,
        isExpanded: isPagesExpanded,
        hasFetchedPages: hasFetchedPages,
        onFetchStart: this.onFetchPagesStart,
        onFetchEnd: this.onFetchPagesEnd,
        groupId: groupId,
        assetId: assetId,
        minorVersion: minorVersion,
        searchTerm: searchTerm
      });
    }
  }, {
    key: "renderVersions",
    value: function renderVersions() {
      var _highlight$versions;
      var _this$props8 = this.props,
        highlight = _this$props8.highlight,
        groupId = _this$props8.groupId,
        assetId = _this$props8.assetId,
        minorVersion = _this$props8.minorVersion;
      var _this$state2 = this.state,
        hasFetchedVersions = _this$state2.hasFetchedVersions,
        isVersionsExpanded = _this$state2.isVersionsExpanded,
        isExpanded = _this$state2.isExpanded,
        versions = _this$state2.versions,
        titleWidths = _this$state2.titleWidths,
        fetchVersionsPromise = _this$state2.fetchVersionsPromise;
      if (!(highlight !== null && highlight !== void 0 && (_highlight$versions = highlight.versions) !== null && _highlight$versions !== void 0 && _highlight$versions.length)) {
        return null;
      }
      return /*#__PURE__*/_react.default.createElement(_Versions.default, {
        versions: versions || highlight.versions,
        isExpanded: isVersionsExpanded && isExpanded,
        fetchVersionsPromise: fetchVersionsPromise,
        titleWidths: titleWidths,
        hasFetchedVersions: hasFetchedVersions,
        onFetchStart: this.onFetchVersionsStart,
        onFetchEnd: this.onFetchVersionsEnd,
        groupId: groupId,
        assetId: assetId,
        minorVersion: minorVersion
      });
    }
  }, {
    key: "renderCustomFields",
    value: function renderCustomFields() {
      var _highlight$fields;
      var highlight = this.props.highlight;
      if (!(highlight !== null && highlight !== void 0 && (_highlight$fields = highlight.fields) !== null && _highlight$fields !== void 0 && _highlight$fields.length)) {
        return null;
      }
      return /*#__PURE__*/_react.default.createElement("table", {
        className: styles.matchesTable,
        "data-test-id": "asset-card-fields"
      }, /*#__PURE__*/_react.default.createElement("tbody", null, highlight.fields.map(function (field, index) {
        return /*#__PURE__*/_react.default.createElement("tr", {
          key: "field-".concat(index)
        }, /*#__PURE__*/_react.default.createElement("td", {
          className: styles.rowTitle
        }, /*#__PURE__*/_react.default.createElement(_exchangeUiComponents.Highlight, null, field.displayName || field.key)), /*#__PURE__*/_react.default.createElement("td", {
          className: styles.tagsContainer
        }, field.value.map(function (fieldValue, valueIndex) {
          return /*#__PURE__*/_react.default.createElement(_Pill.default, {
            className: styles.matchesCategories,
            key: "field-value-".concat(valueIndex),
            disabled: true,
            testId: "match-field"
          }, /*#__PURE__*/_react.default.createElement(_exchangeUiComponents.Highlight, null, fieldValue));
        })));
      })));
    }
  }, {
    key: "renderCategories",
    value: function renderCategories() {
      var highlight = this.props.highlight;
      if (!highlight || !highlight.categories || !highlight.categories.length) {
        return null;
      }
      return /*#__PURE__*/_react.default.createElement("table", {
        className: styles.matchesTable,
        "data-test-id": "asset-card-categories"
      }, /*#__PURE__*/_react.default.createElement("tbody", null, highlight.categories.map(function (category, index) {
        return /*#__PURE__*/_react.default.createElement("tr", {
          key: "category-".concat(index)
        }, /*#__PURE__*/_react.default.createElement("td", {
          className: styles.rowTitle
        }, /*#__PURE__*/_react.default.createElement(_exchangeUiComponents.Highlight, null, category.displayName || category.key)), /*#__PURE__*/_react.default.createElement("td", {
          className: styles.tagsContainer
        }, category.value.map(function (categoryValue, valueIndex) {
          return /*#__PURE__*/_react.default.createElement(_Pill.default, {
            className: styles.matchesCategories,
            key: "category-value-".concat(valueIndex),
            disabled: true,
            testId: "match-category"
          }, /*#__PURE__*/_react.default.createElement(_exchangeUiComponents.Highlight, null, categoryValue));
        })));
      })));
    }
  }, {
    key: "renderTags",
    value: function renderTags() {
      var highlight = this.props.highlight;
      if (!highlight || !highlight.labels || !highlight.labels.length) {
        return null;
      }
      return /*#__PURE__*/_react.default.createElement("div", {
        className: styles.tagsContainer
      }, highlight.labels.map(function (tag, index) {
        return /*#__PURE__*/_react.default.createElement(_Pill.default, {
          className: styles.matchesTags,
          key: "tag-".concat(index),
          testId: "match-tag",
          disabled: true
        }, /*#__PURE__*/_react.default.createElement(_exchangeUiComponents.Highlight, null, tag));
      }));
    }
  }, {
    key: "getMatches",
    value: function getMatches() {
      var _this$props9 = this.props,
        highlight = _this$props9.highlight,
        isPortalReArchitectureEnabled = _this$props9.isPortalReArchitectureEnabled;
      var pages = this.state.pages;
      var pagesContent = this.renderPages();
      var categories = this.renderCategories();
      var fields = this.renderCustomFields();
      var tags = this.renderTags();
      var versions = this.renderVersions();
      var matches = [];
      var pagesLength;
      if (pages) {
        pagesLength = pages.length;
      } else if (pagesContent) {
        pagesLength = highlight.pages.length;
      }
      if (pagesContent) {
        matches.push({
          title: "Pages".concat(pagesLength ? " (".concat(pagesLength, ")") : ''),
          content: pagesContent,
          id: 'pages'
        });
      }
      if (categories) {
        matches.push({
          title: "Categories (".concat(highlight.categories.length, ")"),
          content: categories,
          id: 'categories'
        });
      }
      if (fields) {
        matches.push({
          title: "Custom fields (".concat(highlight.fields.length, ")"),
          content: fields,
          id: 'fields'
        });
      }
      if (tags) {
        matches.push({
          title: "Tags (".concat(highlight.labels.length, ")"),
          content: tags,
          id: 'tags'
        });
      }
      if (versions && isPortalReArchitectureEnabled) {
        matches.push({
          title: "Patch versions",
          content: versions,
          id: 'versions'
        });
      }

      // eslint-disable-next-line react/destructuring-assignment
      return this.props.getMatches(matches);
    }
  }, {
    key: "renderMatches",
    value: function renderMatches() {
      var _this$props10 = this.props,
        groupId = _this$props10.groupId,
        assetId = _this$props10.assetId,
        type = _this$props10.type,
        searchTerm = _this$props10.searchTerm,
        organizationId = _this$props10.organizationId,
        resultPosition = _this$props10.resultPosition,
        startExpanded = _this$props10.startExpanded;
      var _this$state3 = this.state,
        isExpanded = _this$state3.isExpanded,
        initialMatchId = _this$state3.initialMatchId;
      var matches = this.getMatches();
      if (!matches.length) {
        return null;
      }
      return /*#__PURE__*/_react.default.createElement(_Matches.default, {
        matches: matches,
        initialMatchId: initialMatchId,
        startExpanded: isExpanded !== undefined ? isExpanded : startExpanded,
        groupId: groupId,
        assetId: assetId,
        type: type,
        searchTerm: searchTerm,
        organizationId: organizationId,
        resultPosition: resultPosition,
        onToggle: this.handleMatchesToggle
      });
    }
  }, {
    key: "renderIcon",
    value: function renderIcon() {
      var _this$props11 = this.props,
        type = _this$props11.type,
        name = _this$props11.name,
        icon = _this$props11.icon,
        isCertified = _this$props11.isCertified;
      var hasIconError = this.state.hasIconError;
      return /*#__PURE__*/_react.default.createElement(_exchangeUiComponents.AssetImage, {
        type: type,
        icon: hasIconError ? null : icon,
        alt: name,
        isCertified: isCertified,
        onLoadError: this.onImageError,
        ariaHidden: true
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props12 = this.props,
        highlight = _this$props12.highlight,
        minorVersion = _this$props12.minorVersion,
        name = _this$props12.name,
        onNavigateAsset = _this$props12.onNavigateAsset,
        assetId = _this$props12.assetId;
      return /*#__PURE__*/_react.default.createElement("article", {
        className: styles.container,
        "aria-label": this.buildCardLabel(),
        "data-card-asset-id": assetId
      }, /*#__PURE__*/_react.default.createElement(_exchangeReactHooks.RouterContext.Consumer, null, function (_ref2) {
        var getPath = _ref2.getPath;
        return /*#__PURE__*/_react.default.createElement(_reactRouterDom.Link, {
          "data-test-id": "asset-card",
          to: _this2.buildAssetPath(getPath),
          tabIndex: "0",
          onClick: onNavigateAsset,
          onKeyDown: eventsUtils.onEnterKey(onNavigateAsset),
          className: (0, _classnames.default)(styles.assetCard, styles.override),
          "aria-label": "Go to ".concat(name, " portal")
        }, _this2.renderIcon(), /*#__PURE__*/_react.default.createElement("div", {
          className: styles.detail,
          role: "listitem"
        }, /*#__PURE__*/_react.default.createElement("div", {
          className: styles.assetTitle
        }, /*#__PURE__*/_react.default.createElement("div", {
          "data-test-id": "asset-card-name",
          className: styles.name,
          title: name,
          "aria-hidden": true
        }, highlight && highlight.name ? /*#__PURE__*/_react.default.createElement(_exchangeUiComponents.Highlight, null, highlight.name) : name), /*#__PURE__*/_react.default.createElement("div", {
          className: styles.version,
          "data-test-id": "asset-card-minor-version"
        }, minorVersion, ".x")), _this2.renderMetadata(), _this2.renderDescription(), _this2.renderMatches()));
      }));
    }
  }]);
}(_react.default.Component);
(0, _defineProperty2.default)(AssetCard, "propTypes", {
  assetId: _propTypes.default.string.isRequired,
  createdBy: _propTypes.default.string.isRequired,
  description: _propTypes.default.string,
  getMatches: _propTypes.default.func,
  groupId: _propTypes.default.string.isRequired,
  highlight: _propTypes.default.object,
  icon: _propTypes.default.string,
  isCertified: _propTypes.default.bool,
  minorVersion: _propTypes.default.string.isRequired,
  minorVersionModifiedAt: _propTypes.default.string.isRequired,
  name: _propTypes.default.string.isRequired,
  numberOfRates: _propTypes.default.number,
  highlightedStatus: _propTypes.default.string,
  onNavigateAsset: _propTypes.default.func,
  organization: _propTypes.default.string.isRequired,
  organizationId: _propTypes.default.string.isRequired,
  resultPosition: _propTypes.default.number,
  rating: _propTypes.default.number,
  startExpanded: _propTypes.default.bool,
  type: _propTypes.default.string.isRequired,
  searchTerm: _propTypes.default.string.isRequired,
  isPortalReArchitectureEnabled: _propTypes.default.bool
});
(0, _defineProperty2.default)(AssetCard, "defaultProps", {
  description: null,
  getMatches: function getMatches(matches) {
    return matches;
  },
  highlight: null,
  icon: null,
  highlightedStatus: null,
  isCertified: false,
  numberOfRates: 0,
  resultPosition: 0,
  onNavigateAsset: function onNavigateAsset() {},
  rating: 0,
  startExpanded: false,
  isPortalReArchitectureEnabled: false
});
(0, _defineProperty2.default)(AssetCard, "contextType", _exchangeReactHooks.AssetTypesConfigurationContext);
(0, _defineProperty2.default)(AssetCard, "styles", styles);
var _default = exports.default = AssetCard;
//# sourceMappingURL=AssetCard.js.map